import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M7.5 24.5a12 12 0 1117 0 12 12 0 01-17 0m-1.4 1.4a14 14 0 100-19.8 14 14 0 000 19.8z"/><path d="M17 17h6a1 1 0 000-2h-6V9a1 1 0 00-2 0v6H9a1 1 0 100 2h6v6a1 1 0 002 0z"/>';
export var PlusCircleOutlineSVG = function PlusCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PlusCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PlusCircleOutlineSVG);